
import { Component, Prop, Vue } from 'vue-property-decorator';
import JobbookingCreateForm from '@/components/forms/JobbookingCreateForm.vue';
import { fetchDetailedJob } from '@/helpers/fetchers';
import { JobDetailedData } from '@/models/jobDetailed';
import * as routeNames from '@/router/routeNames';

@Component({
  components: {
    JobbookingCreateForm,
  },
})
export default class CloneJobbookingView extends Vue {
  @Prop(Number) public jobId: number;
  @Prop(String) public jobDate: string;

  public isLoading = false;
  public detailedJob: JobDetailedData | null = null;

  private created() {
    this.isLoading = true;
    fetchDetailedJob(this.jobId, this.jobDate)
      .then((detailedJob: JobDetailedData) => {
        this.detailedJob = detailedJob;
      })
      .catch(() => {
        this.$router.push({ name: routeNames.INITIAL_ERROR });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
